export enum FileUploadDirectories {
    avatars = 'avatar',
    import = 'import',
    recruiting = 'recruiting',
    documents = 'documents',
    general = 'general',
    audio = 'audio',
}
